var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-switcher"},[_c('v-combobox',{attrs:{"label":"Mentee","items":_vm.managedUsers},on:{"change":_vm.switchUser},model:{value:(_vm.mentee),callback:function ($$v) {_vm.mentee=$$v},expression:"mentee"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }